<template>
  <v-dialog v-model="isDialogOpen" scrollable persistent max-width="600">
    <v-card>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-file-document-edit</v-icon
          >{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.addPDF'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- <v-form ref="form" v-model="valid" v-on:submit.prevent="validate"> -->
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <v-row>
            <v-col>
              <p class="mb-2 body-1 font-weight-medium">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.fileTitle'
                  )
                }}
              </p>
              <v-text-field
                outlined
                v-model="title"
                :rules="nameRules"
                :placeholder="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.title'
                  )
                "
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <div v-if="!pdfDetail">
          <p class="body-1 font-weight-medium mb-0">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.uploadFile'
              )
            }}
          </p>
          <v-row>
            <v-col cols="12" lg="4">
              <div class="upload-btn-wrapper">
                <button class="upload-image-button body-1 font-weight-light">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.chooseFile'
                    )
                  }}
                </button>
                <input
                  type="file"
                  name="myfile"
                  @change="selectFile"
                  accept="application/pdf"
                  :disable="loadingBtn"
                />
              </div>
            </v-col>
            <v-col cols="12" lg="8">
              <div class="progressContainer">
                <p class="mb-0" v-if="fileName !== ''">{{ fileName }}</p>
                <!-- <div>{{percent}}</div> -->
                <div class="d-flex" v-if="showUploadPercent">
                  <v-progress-linear
                    class="mt-2"
                    v-model="progressPercent"
                    height="10"
                    reactive
                  ></v-progress-linear>

                  <p class="ml-2" style="margin-top: 2px">
                    {{ progressPercent }}%
                  </p>
                </div>

                <div class="timeLeft">{{ timeLeft }}</div>
              </div>
            </v-col>
          </v-row>
          </div>
          <v-row>
            <v-col class="examplePDF">
              <p class="mb-2 body-1 font-weight-medium">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.sample'
                  )
                }}
              </p>
              <iframe class="iframePDF" :src="pdfSrc"></iframe>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col class="text-right">
              <v-btn
                elevation="0"
                class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
                outlined
                @click="close"
                >{{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                  )
                }}</v-btn
              >
              <v-btn
                elevation="0"
                class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
                :disabled="!valid"
                :loading="loadingBtn"
                @click="validate"
                >{{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.save'
                  )
                }}</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { headersWithTokenForImage, domain } from '@/service/configApi';
import { insertPdf, updatePdf } from '@/service/course/livev2';
// import { getPrivatePdf } from "@/service/upload/upload.js";
import axios from 'axios';
export default {
  props: {
    isDialogOpen: {
      type: Boolean,
    },
    liveId: {
      type: String,
    },
    pdfDetail: {
      type: Object,
    },
    total: {
      type: Number,
    },
    closeDialog: {
      type: Function,
    },
  },
  watch: {
    isDialogOpen: async function (newValue) {
      if (newValue) {
        this.progressPercent = 0;
        if (this.pdfDetail) {
          // this.priority = this.pdfDetail.priority
          // this.description = this.pdfDetail.description
          this.title = this.pdfDetail.title;
          // this.fileName = this.pdfDetail.title;
          this.pdfSrc = this.pdfDetail.url;
          // this.oldPdfSrc = this.pdfDetail.url;
        }
      }
    },
  },
  data: () => ({
    // valid: true,

    //progress
    progressPercent: 0,
    showUploadPercent: false,
    title: '',
    timeLeft: '',
    percent: '',
    pdfSrc: '',
    pdfFile: null,
    // pdfUploadId: null,
    pdfDetail: null,
    pdfFileDetail: null,
    successStatus: false,
    oldPdfSrc: null,
    // disableBtn: false,
    modelFile: null,
    fileName: '',
    loadingBtn: false,
  }),
  computed: {
    nameRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.titleRules'
          ),
      ];
    },
    valid() {
      return this.title!=='' && this.pdfSrc!==''
    }
  },
  methods: {
    async clearData() {
      this.valid = true;
      this.progressPercent = 0;
      this.showUploadPercent = false;
      this.title = '';
      this.timeLeft = '';
      this.percent = '';
      this.pdfSrc = '';
      this.pdfFile = null;
      this.pdfUploadId = null;
      this.pdfDetail = null;
      this.fileName = '';
      this.successStatus = false;
      // this.disableBtn = false;
      this.loadingBtn = false;
      await this.$refs.form.resetValidation();
      // await this.isPdfClose();
    },
    selectFile(event) {
      let file = event.target.files[0];
      this.pdfFile = file;
      this.fileName = file.name;
      this.pdfSrc = URL.createObjectURL(file);
      event.target.value = null
    },
    async uploadFile() {
      this.showUploadPercent = true;
      this.progressPercent = 0;

      let formData = new FormData();
      formData.append('fileupload', this.pdfFile);
      formData.append('title', this.title);
      await axios
        .post(`${domain}/uploadfile/public/pdfReturnAll/live`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.pdfFileDetail = response.data.result
            this.pdfUploadId = response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
        });
    },
    async close(){
      await this.clearData()
      await this.closeDialog()
    },
    async validate() {
      // this.disableBtn = true
      this.loadingBtn = true
      if (this.$refs.form.validate()) {
        if (this.pdfDetail == null) {
          await this.uploadFile();
          if (this.pdfFileDetail) {
            let result = await insertPdf(this.liveId,{
              ...this.pdfFileDetail,
              priority: this.total,
              title: this.title,
              description: '',
            });
            if (!result.code) {
              this.close();
            }
            // this.loadingBtn = false
          }
        } else {
          // if (this.oldPdfSrc !== this.pdfSrc) {
          //   await this.uploadFile();
          // }
          let result = await updatePdf(this.liveId, this.pdfDetail._id,{
            // idpdf: this.pdf._id,
            // liveIdstream: this.liveId,
            ...this.pdfDetail,
            title: this.title,
            // description: '',
            // pdf: this.pdfUploadId,
          });
          if (!result.code) {
            this.close();
          }
          // this.disableBtn = false;
        }
      }
      this.loadingBtn = false
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-image-button {
  border-radius: 8px;
  border-color: rgba(65, 65, 65, 0.3);
  padding: 8px 20px;
  font-size: 16px;
  width: 100%;
  /* color: rgb(65, 65, 65); */
  border: 1px solid rgb(195, 195, 195);
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
}

.btn-choose {
  color: white;
  background-color: #1976d2;
  padding: 8px 20px;
  font-size: 16px;
  width: 100%;
  border-radius: 5px;
}

.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  &:hover {
    cursor: pointer;
  }
}
.examplePDF {
  /* height: 450px; */
  text-align: left;
}
.iframePDF {
  width: 100%;
  border: 1px dashed #e9e9e9;
  background: #fbfbfb;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
</style>